import { BasicRegister } from './../../../models/basic-register.model';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { identity } from 'rxjs';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  @Input() user: BusinessUser;

  public changing: boolean = false;
  public _loading: boolean = false;
  public formEditUser: UntypedFormGroup;
  public business: BasicRegister;

  constructor(
    public api: MgService,
    private _snackBar: MatSnackBar,
    private activedRouter: ActivatedRoute,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.formEditUser = this.fb.group({
      id: [null],
      business_id: [null, [Validators.required]],
      name: [undefined, [Validators.required]],
      email: [undefined, [Validators.required, Validators.email]],
      mobile: [undefined, Validators.required],
      can_see_all: [undefined],
      is_actived: [true],
      password: [undefined]
    });

    let user = this.activedRouter.snapshot.params.id;
    this.loadUserBusiness(user);
  }

  public onSubmit() {
    this.api.storeBusinessUser(this.formEditUser.value)
    .subscribe(
      res => {
        this.openSnackBar()
        this.toBack();
      }
    )
  }

  public toBack(){
    history.back();
  }

  public changeCompany() {
    this.changing = !this.changing;
  }

  openSnackBar() {
    this._snackBar.open('Dados alterados com Sucesso', 'Fechar', {
      duration: 3000,
    });
  }

  public businessSelected(business: BasicRegister) {
    this.formEditUser.controls.business_id.setValue(business.id);
    this.business = business
    this.changing = !this.changing;
  }

  public loadUserBusiness(user: number) {
    this._loading = true;
    this.api.showBusinessUser(user)
      .subscribe(
        res => {
          let user: BusinessUser = res.data;

          this.business = user.business

          this.formEditUser.setValue({
            id: user.id,
            business_id: user.business_id,
            name: user.name,
            email: user.email,
            mobile: user.mobile,
            can_see_all: user.can_see_all,
            is_actived: user.is_actived,
            password: "",
          })
          this._loading = false;
        }
      )
  }

}
